import React, { Component } from 'react';
import Axios from 'axios';
import { login } from '../redux/Action';
import { API_URL } from '../API_url/API_URL';
import { Table, Input, Label, Button } from 'reactstrap';
import { TableBody, TableHead, TableCell, TableRow } from '@material-ui/core'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

class Admin extends Component {
    state = {
        data: [],
        openModal: false,
        selectedID: null,
        redirectMovies: false
    }

    componentDidMount(){
        Axios.get(API_URL+'/movies')
        .then((res) => {
            this.setState({data: res.data})
            console.log(this.state.data)
        })
        .catch((err) => {
            console.log(err)
        })
    }

    renderSynopsis = (text) => {
        let arrSync = text.split(' ')
        var output = []
        for (var i=0; i<5; i++){
            output.push(arrSync[i])
        }
        return output.join(' ') + ('...')
    }

    renderMovies = () => {
        let { data, selectedID} = this.state;
        let { role } = this.props
        if(role === 'user'){
            this.setState({redirectMovies: true})
        }
        return data.map((val) => {
            if(val.id === selectedID){
                return(
                    <TableRow>
                        <TableCell>
                            {val.id}
                        </TableCell>
                        <TableCell>
                            <Input defaultValue={val.name} innerRef={(name) => this.name= name}/>
                        </TableCell>
                        <TableCell>
                            <Input defaultValue={val.director} innerRef={(director) => this.director = director}/>
                        </TableCell>
                        <TableCell>
                            <Input defaultValue={val.image} innerRef={(image) => this.image = image}/>
                        </TableCell>
                        <TableCell>
                            <Input defaultValue={val.genre} innerRef={(genre) => this.genre = genre}/>
                        </TableCell>
                        <TableCell>
                            <Input defaultValue={val.duration} type='number' innerRef={(duration) => this.duration = duration}/>
                        </TableCell>
                        <TableCell>
                            <Input defaultValue={val.synopsis} innerRef={(synopsis) => this.synopsis = synopsis}/>
                        </TableCell>
                        <TableCell>
                            <Input defaultValue={val.casts} innerRef={(casts) => this.casts = casts}/>
                        </TableCell>
                        <TableCell>
                            <Button color='success' onClick={()=> this.confirmEdit(val.id)}>Confirm</Button>
                            <Button color='warning' onClick={() => this.setState({selectedID: null})}>Cancel</Button>
                        </TableCell>
                    </TableRow>
                )
            }
            return (
                <TableRow>
                    <TableCell>{val.id}</TableCell>
                    <TableCell>{val.name}</TableCell>
                    <TableCell>{val.director}</TableCell>
                    <TableCell>{<img src={val.image} alt='poster movie' style={{width: '100px'}} />}</TableCell>
                    <TableCell>{val.genre.map((genre) => {
                        return (
                            `${genre}, `
                        )
                    })}
                    </TableCell>
                    <TableCell>{val.duration} minutes</TableCell>
                    <TableCell>{this.renderSynopsis(val.synopsis)}</TableCell>
                    <TableCell>{val.casts.map((cast) => {
                        return (
                            `${cast}, `
                        )
                    })}
                    </TableCell>
                    <TableCell>
                        <Button color="warning" onClick={() => this.setState({selectedID: val.id})}>Edit</Button>

                        <Button color='danger' onClick={() => this.deleteMovie(val.id)}>Delete</Button>
                    </TableCell>
                </TableRow>
                
            )
        })
        
    }

    confirmEdit = (id) => {
        let name = this.name.value
        let director = this.director.value;
        let image = this.image.value;
        let genre = this.genre.value.split(',');
        let duration = this.duration.value;
        let synopsis = this.synopsis.value;
        let casts = this.casts.value.split(',');
        let data = {
            name,
            genre, 
            director,
            duration,
            synopsis,
            casts,
            image
        }

        if(name && director && image && genre && duration && synopsis && casts){
            Axios.patch(API_URL+ `/movies/${id}`, data)
            .then(() => {
                Axios.get(API_URL+ '/movies')
                .then((res) => {
                    this.setState({data: res.data, selectedID: null})
                })
            })
            .catch((err) => {
                console.log(err)
            })
        }else{
            alert('Please fill all forms!')
        }
    }
    

    deleteMovie = (id) => {
        Axios.delete(API_URL+`/movies/${id}`)
        .then((res) => {
            Axios.get(API_URL+ '/movies')
            .then((res) => {
                console.log(res.data)
                this.setState({data: res.data})
                alert('Delete movie successful')
            })
        })
        .catch((err) => {
            console.log(err)
        })
    }

    onBtnaddMovie = () => {
        let name = this.name.value
        let director = this.director.value;
        let image = this.image.value;
        let genre = this.genre.value.split(',');
        let duration = this.duration.value;
        let synopsis = this.synopsis.value;
        let casts = this.casts.value.split(',');

        if(name && director && image && genre && duration && synopsis && casts){
            Axios.post(API_URL+ `/movies`, {
                name: name, genre: genre, director: director, duration: duration, synopsis: synopsis, casts: casts, booked: [], image: image
            })
            .then(() => {
                Axios.get(API_URL+ '/movies')
                .then((res) => {
                    this.setState({data: res.data, openModal: false})
                })
            })
            .catch((err) => {
                console.log(err)
            })
        }else{
            alert('Please fill all forms!')
        }
    }

    render() {
        let { openModal } = this.state;
        let { redirectMovies } = this.state
        if(redirectMovies){
            return(
                <Redirect to='/notfound' />
            )
        }
        return(
            <div>
                <Table>
                    <TableHead>
                        <TableCell>ID</TableCell>
                        <TableCell>Title</TableCell>
                        <TableCell>Director</TableCell>
                        <TableCell>Image</TableCell>
                        <TableCell>Genre</TableCell>
                        <TableCell>Duration</TableCell>
                        <TableCell>Synopsis</TableCell>
                        <TableCell>Casts</TableCell>
                        <TableCell>Action</TableCell>
                    </TableHead>
                    <TableBody>
                        {this.renderMovies()}
                    </TableBody>
                </Table>

                <div className='d-flex justify-content-center row'>
                <Button onClick={() => this.setState({openModal: true})}>
                    Add Movie
                </Button>
                <Modal isOpen={openModal} >
                    <ModalHeader >Modal title</ModalHeader>
                    <ModalBody>
                        <Label>
                            Movie Title
                        </Label>
                        <Input innerRef={(name) => this.name= name} />
                        <Label>
                            Director
                        </Label>
                        <Input innerRef={(director) => this.director = director}/>
                        <Label>
                            Image URL
                        </Label>
                        <Input innerRef={(image) => this.image = image}/>
                        <Label>
                            Genre
                        </Label>
                        <Input innerRef={(genre) => this.genre = genre}/>
                        <Label>
                            Duration
                        </Label>
                        <Input innerRef={(duration) => this.duration = duration}/>
                        <Label>
                            Synopsis
                        </Label>
                        <Input innerRef={(synopsis) => this.synopsis = synopsis}/>
                        <Label>
                            Casts
                        </Label>
                        <Input innerRef={(casts) => this.casts = casts}/>
                    </ModalBody>
                    <ModalFooter>
                    <Button color="primary" onClick={this.onBtnaddMovie} >Confirm</Button>{' '}
                    <Button color="secondary" onClick={() => this.setState({openModal: false})}>Cancel</Button>
                    </ModalFooter>
                </Modal>
                </div>
            </div>
        )
    }
}
const mapStatetoProps = ({auth}) => {
    return {
        role: auth.role,
        username: auth.username
    }
}

export default connect(mapStatetoProps, { login })(Admin);